// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-field[data-v-4b426516]{display:inline-block}`, "",{"version":3,"sources":["webpack://./src/components/mailFilter/ActionAddflag.vue"],"names":[],"mappings":"AACA,8BACC,oBAAA","sourcesContent":["\n.input-field {\n\tdisplay: inline-block; /* for flex expand */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
